import { Box } from "@mui/material";
import CanvasIcon from "../assets/canvas.svg?react";
import MoodleIcon from "../assets/moodle.svg?react";
import BlackboardIcon from "../assets/blackboard.svg?react";
import Desire2LearnIcon from "../assets/D2L.svg?react";
import styles from "./LmsIcon.module.css";

export const LMS_TYPES = ["canvas", "moodle", "BlackboardLearn", "desire2learn"] as const;
export type LmsType = (typeof LMS_TYPES)[number];

export const isLmsType = (value?: string): value is LmsType => {
	return value !== undefined && LMS_TYPES.includes(value as LmsType);
};

export const LmsIcon = ({ lms, width = 24, height = 24 }: { lms: LmsType; width?: number; height?: number }) => {
	return (
		<Box className={styles.lmsIcon} width={width} height={height}>
			{lms === "canvas" && <CanvasIcon />}
			{lms === "moodle" && <MoodleIcon />}
			{lms === "BlackboardLearn" && <BlackboardIcon />}
			{lms === "desire2learn" && <Desire2LearnIcon />}
		</Box>
	);
};
